/*=========================================================================================
  File Name: moduleAdminActions.js
  Description: Admin Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
    addAdmin({ commit }, adminUser) {
        return new Promise((resolve, reject) => {
            axios.post("/api/admin-management/admins", { role: adminUser.role, admin: adminUser.admin })
                .then((response) => {
                    if (response.data.resultCode === 303 && response.data.resultMessage === "DUPLICATE_ID") {
                        reject('DUPLICATE_ADMIN_ID_MESSAGE')
                    } else if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    }
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    updateAdmin({ commit }, adminUser) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/admin-management/admins`, { role: adminUser.role, admin: adminUser.admin })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    resetAdmin({ commit }, adminId) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/admin-management/admins/${adminId}`)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchAdminRole({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/role-management/admin-role`)
                .then((response) => {
                    commit('SET_ADMIN_ROLE', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchAdminStatus({ commit }) {
        return new Promise((resolve, reject) => {
            let adminStatus = "ADMIN_STATUS"
            axios.get(`/api/common-code-management/code-group/${adminStatus}`)
                .then((response) => {
                    commit('SET_ADMIN_STATUS', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchAdminBlockedReason({ commit }) {
        return new Promise((resolve, reject) => {
            let adminBlockedReason = "ADMIN_BLOCKED_REASON"
            axios.get(`/api/common-code-management/code-group/${adminBlockedReason}`)
                .then((response) => {
                    commit('SET_BLOCKED_REASON', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    changeAdminPassword({ commit }, adminInfo) {
        return new Promise((resolve, reject) => {
            let adminId = adminInfo.adminId
            axios.put(`/api/admin-management/admins/password/${adminId}`, { currentPassword: adminInfo.currentPassword, newPassword: adminInfo.newPassword })
                .then((response) => {
                    if (response.data.resultCode !== 200) {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    } else{
                        resolve(response)
                    }
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    fetchLoginAdminInformation({ commit }, adminId) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/admin-management/admins-info/${adminId}`)
                .then((response) => {
                    commit('SET_LOGIN_ADMIN_INFO', response.data.resultBody)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    updateLoginAdminInformation({ commit }, admin) {
        return new Promise((resolve, reject) => {
            let adminId = admin.adminId
            axios.put(`/api/admin-management/admins-info/${adminId}`, { name: admin.name, email: admin.email })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
}